import React, { useMemo } from 'react';

import { Icon, IconColorOptions } from '../Icon';

import './styles.scss';

interface Props {
    text: string;
    type: 'danger' | 'blue' | 'green' | 'purple' | 'brown' | 'yellow' | 'violet' | 'dark-blue';
    className?: string;
    icon?: string;
    iconSize?: string;
    iconColor?: IconColorOptions;
}

export const Chip = ({ text, type, className = '', icon, iconSize, iconColor }: Props) => {
    const typeClassName = useMemo(() => {
        switch (type) {
            case 'danger':
                return 'chip--danger';
            case 'blue':
                return 'chip--blue';
            case 'green':
                return 'chip--green';
            case 'purple':
                return 'chip--purple';
            case 'brown':
                return 'chip--brown';
            case 'yellow':
                return 'chip--yellow';
            case 'violet':
                return 'chip--violet';
            case 'dark-blue':
                return 'chip--dark-blue';
            default:
                return '';
        }
    }, [type]);

    return (
        <div className={`chip ${typeClassName} ${className}`}>
            {icon && <Icon icon={icon} size={iconSize || '24'} color={iconColor} className='chip__icon' />}
            <span className='chip__text'>{text}</span>
        </div>
    );
};
